import React, { Fragment } from 'react';

import Item from '~/kits/general/scripts/Item';

export default (props) => {
  return (
    <Fragment>
      <div className="item-epoch">
        <div className="item__title">{props.title}</div>
        <div className="item__duration">{props.duration}</div>
        <div className="item__description"><strong>{props.description}:</strong> {props.description_long}</div>
      </div>
      {props.items.map((item) => (
        <Item
          key={item.id}
          activeItemId={props.activeItemId}
          {...item}
        />
      ))}
    </Fragment>
  );
};
